export const useMenuStyles = () => {
  return {
    '& .MuiMenu-list': {
      padding: 0
    },
    '& .MuiMenuItem-root': {
      paddingLeft: '8px',
      paddingRight: '12px'
    },
    '& .MuiMenuItem-root.Mui-selected, & .MuiMenuItem-root.Mui-selected:hover': {
      background: 'rgba(1, 198, 226, 0.12)'
    },
    '& .MuiListItemIcon-root': {
      justifyContent: 'center',
      minWidth: '20px !important',
      marginRight: '10px',
      '& .MuiSvgIcon-root': {
        fill: 'currentColor'
      }
    }
  };
};
